import { combineReducers, Reducer } from 'redux';
import { reducer as addressReducer } from 'b2b-apps/shop/myAccount/addresses/redux/address/reducer';
import { reducer as addressesReducer } from 'b2b-apps/shop/myAccount/addresses/redux/addresses/reducer';
import { reducer as addressesSearch } from 'b2b-apps/shop/myAccount/addresses/redux/addressesSearch/reducer';
import { AddressesAction, AddressesState } from './types';

const reducer: Reducer<AddressesState, AddressesAction> = combineReducers({
  addresses: addressesReducer,
  address: addressReducer,
  addressesSearch: addressesSearch,
});

export {
  reducer,
};
